import { useCallback, useState } from "react";
import { API, Message } from "../io/Api";
import { ContactProps } from "../components/ContactForm";


const useBedrock = (contact: ContactProps) => {
    const [messages, setConversation] = useState<Message[]>([]);

    const sendMessage = useCallback(async (text: string) => {
        setConversation([...messages, { text, role: 'user' }]);
        const newMessages =
            await API.converse({ 
                messages, 
                text, 
                serviceType: contact.serviceType, 
                promptFields: {...contact} })
        setConversation(newMessages);
    }, [contact, messages]);

    const resetChat = useCallback(() => {
        setConversation([]);
    }, []);

    return { messages, sendMessage, resetChat };
}

export function fuzzyParseJSON(text: string): {[k:string]: string} {
    const stack = new Array<number>();
    let result: {[k:string]: string} = {};
    for (let i = 0; i < text.length; i++) {
        const c = text.charAt(i);
        if (c === '{') {
            stack.push(i);
        }
        else if (c === '}') {
            const j = stack.pop() || 0;
            if (stack.length === 0) {
                result = {...result, ...JSON.parse(text.substring(j, i+1))};
            }
        }
    }
    return result;
}

export default useBedrock;